<template>
  <BaseAction>
    <SecondaryButton
      @click.native="openSubmitForApprovalDialog"
      color="primary"
    >
      <div class="d-flex justify-center">
        <v-icon size="1.5rem">
          mdi-briefcase-outline
        </v-icon>
        <v-icon size="1rem">
          mdi-arrow-right
        </v-icon>
      </div>
      Submit for Approval
    </SecondaryButton>
    <BookingApprovalDialog
      :isOpen="isSubmitForApprovalOpen"
      @close="closeSubmitForApprovalDialog"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BookingApprovalDialog from "@/views/bookings/components/ConfirmDialogs/BookingApprovalDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "SubmitForApprovalAction",
  components: { BaseAction, BookingApprovalDialog, SecondaryButton },
  data() {
    return {
      isSubmitForApprovalOpen: false
    };
  },
  methods: {
    openSubmitForApprovalDialog() {
      this.isSubmitForApprovalOpen = true;
    },
    closeSubmitForApprovalDialog() {
      this.isSubmitForApprovalOpen = false;
    }
  }
};
</script>
